var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-insumos"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"listadoInsumos":_vm.listadoInsumos}})]:[_c('desktop',{attrs:{"listadoInsumos":_vm.listadoInsumos}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }